<div class="flex flex-col gap-4">
  <h1 class="text-center">Herzlich willkommen!</h1>
  <p class="text-center">
    Deine Karriere bei TauRes startet gleich nach der Verifizierung durch dein Geburtsdatum. Dann bitten wir dich nur noch, die
    Datenschutzeinwilligung und die Verschwiegenheitsvereinbarung aufmerksam zu lesen, bevor du auf unser Karriereportal weitergeleitet wirst.
    <br /><br />
    Wir freuen uns auf dich!
  </p>
  <form [formGroup]="form" class="flex flex-col gap-2 max-w-[500px] w-full mx-auto" (submit)="verify()">
    <h5 class="m-0">Verifizierung</h5>
    <p-fluid>
      <p-datePicker
        id="birthdate"
        [formControl]="form.controls.dateOfBirth"
        [showIcon]="true"
        iconDisplay="input"
        dateFormat="dd.mm.yy"
        placeholder="Bitte gib hier dein Geburtsdatum ein"
        [required]="true"
        [class.ng-invalid]="stateService.getHasError()"
      />
      @if (stateService.getHasError()) {
        <span class="form-hint-text-error">Daten konnten nicht verifiziert werden.</span>
      }
    </p-fluid>

    <p-fluid>
      <p-button type="button" (click)="verify()" [disabled]="stateService.getIsLoading() || form.invalid" [loading]="stateService.getIsLoading()">
        Weiter
      </p-button>
    </p-fluid>
  </form>
</div>
